import React from 'react'
import { Popup } from '../../../../../components/Popup'
import { Text } from '../../../../../designSystem'
import '../chapterAddEdit.css'

function RestrictDelete({ restrictDelete, setRestrictDelete }) {
  return (
    <Popup
      show={restrictDelete}
      close={() => setRestrictDelete(false)}
      renderActions={
        <>
          <button
            className="action-button"
            type="button"
            onClick={() => setRestrictDelete(false)}
          >
            Close
          </button>
        </>
      }
    >
      <Text variant="caption" lineHeight={1.8} fontWeight={500}>
        To modify the chapters, please reach out to{' '}
        <a href="mailto: writers@pocketfm.in">writers@pocketfm.in</a>, to
        support for the same along with book name & reason
      </Text>
    </Popup>
  )
}

export default RestrictDelete